import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { SupplierSearchComponent } from './supplier-search/supplier-search.component';
import { MsalGuard } from '@azure/msal-angular';


const routes: Routes = [
  {
    path: '',
    component: SupplierSearchComponent,
    canActivate: [MsalGuard]
  },
  {
    path: '',
    redirectTo: 'supplier-search',
    pathMatch: 'full'
  },
  {
    path: '**',
    redirectTo: 'supplier-search'
  }
];

@NgModule({
  imports: [RouterModule.forRoot(routes, { initialNavigation: 'enabledBlocking' })],
  exports: [RouterModule]
})
export class AppRoutingModule {
}
